import { useEffect, useRef } from 'react';

export default function HexagonBackground() {
  const ref = useRef(null);

  useEffect(() => {
    let frameId = null;

    const handleMove = (event) => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(() => {
        if (ref.current) {
          ref.current.style.setProperty('--mouse-x', `${event.clientX}px`);
          ref.current.style.setProperty('--mouse-y', `${event.clientY}px`);
        }
        frameId = null;
      });
    };

    window.addEventListener('mousemove', handleMove);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, []);

  return (
    <div className="hexagon-bg" ref={ref} aria-hidden="true">
      <div className="hexagon-layer hexagon-layer-primary" />
      <div className="hexagon-layer hexagon-layer-secondary" />
      <div className="hexagon-spotlight" />
    </div>
  );
}
